import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectOneTwoTripBannerExperimentEnabled } from '../../selectors/experiments/selectOneTwoTripBannerExperimentEnabled';
import { ApplicationContext } from '../../utils/applicationContext';
import { trackSlideClick, trackSlideShow } from './tracking';

export type TOneTwoTripCarouselSlide = {
  cityName: string;
  text: string;
  imageUrl: string;
  price: number;
  url: string;
  urlPart: string;
  analyticsLabel: string;
};

const ONE_TWO_TRIP_URL =
  'https://cian.onetwotrip.com/?activePage=hotel&isStart=false&utm_source=cian&utm_medium=partner&utm_campaign=home_page_collection&636bd81ac76114bf06b41e60=';

export const useOneTwoTripCarousel = () => {
  const { config } = React.useContext(ApplicationContext);
  const [slides, setSlides] = React.useState<TOneTwoTripCarouselSlide[]>([]);

  const isOneTwoTripBannerExperimentEnabled = useSelector(selectOneTwoTripBannerExperimentEnabled);

  React.useEffect(() => {
    const slides =
      (isOneTwoTripBannerExperimentEnabled &&
        config.get<TOneTwoTripCarouselSlide[]>('frontendMainPage.popularTouristDirections')) ||
      [];

    setSlides([...slides].sort(() => 0.5 - Math.random()));
  }, [isOneTwoTripBannerExperimentEnabled, config]);

  const onSlideShow = React.useCallback(trackSlideShow, []);
  const onSlideClick = React.useCallback(({ urlPart, url, analyticsLabel }: TOneTwoTripCarouselSlide) => {
    trackSlideClick(analyticsLabel);

    const urlToOpen = url ? url : `${ONE_TWO_TRIP_URL}${encodeURIComponent(urlPart)}`;

    window.open(urlToOpen, '_blank');
  }, []);

  return React.useMemo(() => ({ slides, onSlideClick, onSlideShow }), [slides, onSlideClick, onSlideShow]);
};
